import { defineMessages } from 'react-intl'

export default defineMessages({
  addAvailability: {
    id: 'containers.SupplierProfile.components.Availability.addAvailability',
    defaultMessage: 'Register another unavailability',
  },
  addNewAvailability: {
    id: 'containers.SupplierProfile.components.Availability.addNewAvailability',
    defaultMessage: 'Register unavailability',
  },
  addNewBooking: {
    id: 'containers.SupplierProfile.components.Availability.addNewBooking',
    defaultMessage: 'Booking Request',
  },
  cancel: {
    id: 'containers.SupplierProfile.components.Availability.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'containers.SupplierProfile.components.Availability.delete',
    defaultMessage: 'Delete',
  },
  details: {
    id: 'containers.SupplierProfile.components.Availability.details',
    defaultMessage: 'Details',
  },
  edit: {
    id: 'containers.SupplierProfile.components.Availability.edit',
    defaultMessage: 'Edit',
  },
  save: {
    id: 'containers.SupplierProfile.components.Availability.save',
    defaultMessage: 'Save',
  },
  accept: {
    id: 'containers.SupplierProfile.components.Availability.accept',
    defaultMessage: 'Accept',
  },
  reject: {
    id: 'containers.SupplierProfile.components.Availability.reject',
    defaultMessage: 'Reject',
  },
  availabilityMessageLabel: {
    id: 'containers.SupplierProfile.components.Availability.availabilityMessage.label',
    defaultMessage: 'Note',
  },
  availabilityMessagePlaceholder: {
    id: 'containers.SupplierProfile.components.Availability.availabilityMessage.placeholder',
    defaultMessage: 'Add your notes here',
  },
  bookingMessageLabel: {
    id: 'containers.SupplierProfile.components.Availability.bookingMessage.label',
    defaultMessage: 'Deal ID',
  },
  bookingMessagePlaceholder: {
    id: 'containers.SupplierProfile.components.Availability.bookingMessage.placeholder',
    defaultMessage: 'Add deal id',
  },
  fromLabel: {
    id: 'containers.SupplierProfile.components.Availability.from.label',
    defaultMessage: 'From',
  },
  toLabel: {
    id: 'containers.SupplierProfile.components.Availability.to.label',
    defaultMessage: 'To',
  },
  booking: {
    id: 'containers.SupplierProfile.components.Availability.to.booking',
    defaultMessage: 'Booking',
  },
  unavailability: {
    id: 'containers.SupplierProfile.components.Availability.to.availability',
    defaultMessage: 'Unavailability',
  }
})
